/* Gourdeous Porches — metro-only visibility for inner pages.
 * Elements with [data-gp-metro-only="denver|omaha_lincoln|phoenix"] show only
 * for the active metro (FAQ variants, scheduling windows, tax lines...).
 */
(function () {
  "use strict";
  function md() {
    var el = document.getElementById("gp-market-data");
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function metro() {
    var d = md();
    var f = (d && d.defaultMetro) || "denver";
    if (window.GPMetro) {
      var m = window.GPMetro.get();
      return d && d.markets[m] ? m : f;
    }
    return f;
  }
  function apply() {
    var mk = metro();
    document.querySelectorAll("[data-gp-metro-only]").forEach(function (el) {
      el.hidden = el.getAttribute("data-gp-metro-only") !== mk;
    });
  }
  function boot() {
    apply();
    document.addEventListener("gp:metro", apply);
    if (!window.GPMetro) {
      var n = 0;
      var t = setInterval(function () {
        n++;
        if (window.GPMetro || n > 24) { clearInterval(t); if (window.GPMetro) apply(); }
      }, 250);
    }
    window.addEventListener("load", apply);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else { boot(); }
})();

/* v9 (2026-07-23): tier pick-echo — clicking a tier CTA with [data-gp-pick]
 * echoes "Asking about: <package>" above the capture form (#notify). */
(function () {
  "use strict";
  function wire() {
    var echo = document.querySelector("[data-gp-pick-echo]");
    var slot = document.querySelector("[data-gp-pick-name]");
    if (!echo || !slot) return;
    document.querySelectorAll("[data-gp-pick]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        slot.textContent = btn.getAttribute("data-gp-pick");
        echo.hidden = false;
      });
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", wire);
  } else { wire(); }
})();
